import React from 'react';
import { Dumbbell, CheckSquare, GitBranch } from 'lucide-react';

/**
 * Компонент с дополнительными параметрами для расчета максимального пульса
 */
const AdvancedParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  fitnessLevels,
  sportTypes
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-red-500" />
        Дополнительные параметры
      </h3>
      
      {/* Уровень физической подготовки */}
      <div className="mb-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="includeFitnessAdjustment"
            checked={formData.includeFitnessAdjustment}
            onChange={handleInputChange}
            className="form-checkbox"
          />
          <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
            Учитывать уровень физической подготовки
          </span>
        </label>
        <p className="text-xs text-gray-500 dark:text-gray-400 ml-6 mt-1">
          Регулярные тренировки могут повысить ваш максимальный пульс, в то время как начинающим рекомендуется быть более осторожными
        </p>
      </div>

      {/* Выбор уровня подготовки */}
      {formData.includeFitnessAdjustment && (
        <div className="mb-4 pl-6 border-l-2 border-red-200 dark:border-red-800">
          <label htmlFor="fitnessLevel" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Dumbbell className="w-4 h-4 mr-2 text-red-500" />
            Уровень физической подготовки
          </label>
          <select
            id="fitnessLevel"
            name="fitnessLevel"
            value={formData.fitnessLevel}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.fitnessLevel ? 'input-error' : ''}`}
          >
            {fitnessLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            {fitnessLevels.find(level => level.id === formData.fitnessLevel)?.description || ''}
          </p>
          {errors.fitnessLevel && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.fitnessLevel}
            </p>
          )}
        </div>
      )}

      {/* Тип физической активности */}
      <div>
        <label htmlFor="sportSpecific" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
          <GitBranch className="w-4 h-4 mr-2 text-red-500" />
          Тип физической активности
        </label>
        <select
          id="sportSpecific"
          name="sportSpecific"
          value={formData.sportSpecific}
          onChange={handleInputChange}
          className={`form-select w-full ${errors.sportSpecific ? 'input-error' : ''}`}
        >
          {sportTypes.map((sport) => (
            <option key={sport.id} value={sport.id}>
              {sport.name}
            </option>
          ))}
        </select>
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Выберите тип активности, для которой вы рассчитываете зоны пульса. Разные виды спорта имеют свои особенности в нагрузке на сердечно-сосудистую систему.
        </p>
        {errors.sportSpecific && (
          <p className="mt-1 text-xs text-red-500 dark:text-red-400">
            {errors.sportSpecific}
          </p>
        )}
      </div>

      {/* Информация о различиях в тренировках */}
      <div className="mt-4 bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800">
        <div className="flex items-start">
          <GitBranch className="w-5 h-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Специфика разных видов спорта
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              В плавании сердечный ритм обычно ниже из-за горизонтального положения и эффекта погружения в воду.
              В беге и других видах спорта с высокой ударной нагрузкой пульс может быть выше.
              Силовые тренировки характеризуются резкими скачками пульса, а циклические виды спорта — более ровной кардионагрузкой.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvancedParametersSection;